'use client'
import { userContext } from '@components/context/userContext'
import FullCart from '@components/templates/CartFull'
import { useRouter } from 'next/navigation'
import { FC, Suspense, useContext, useEffect } from 'react'

const Page: FC = () => {
  const router = useRouter()
  const user = useContext(userContext)

  const placeOrderClick = () => {
    router.push('/shopping-cart/address')
  }

  useEffect(() => {
    // setting location coords to the first address
    if (user.addresses && user.addresses.length > 0) {
      const defaultAddress = user.addresses[0]
      user.setLocationCoords({
        displayAdress: defaultAddress.address,
        latitude: Number(defaultAddress.latitude),
        longitude: Number(defaultAddress.longitude),
        isInsideTheCity: true
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="md:pt-10">
      <Suspense fallback={<div>Loading....</div>}>
        <FullCart />
      </Suspense>
    </div>
  )
}
export default Page
